import { Component } from '@theme/component';
import { CartAddEvent, ThemeEvents } from '@theme/events';

export default class ProductFormComponent extends Component {
  connectedCallback() {
    super.connectedCallback();

    document.addEventListener(
      ThemeEvents.variantUpdate,
      this.#onVariantUpdate.bind(this)
    );
  }

  async handleSubmit(event) {
    event.preventDefault();

    const form =
      event.target instanceof HTMLFormElement
        ? event.target
        : this.querySelector('form');

    if (!(form instanceof HTMLFormElement)) {
      console.error('Product form not found.');
      return;
    }

    const variantId = this.refs.variantId;

    if (!(variantId instanceof HTMLInputElement) || !variantId.value) {
      console.error('Variant ID is missing.');
      return;
    }

    const formData = new FormData(form);
    const submitButton = this.refs.submitButton;

    if (submitButton instanceof HTMLButtonElement) {
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.description || 'Cart add failed');
      }

      document.dispatchEvent(new CartAddEvent(data));

      const liveRegion = this.refs.liveRegion;

      if (liveRegion instanceof HTMLElement) {
        liveRegion.textContent = `${data.title} added to cart`;
      }
    } catch (error) {
      console.error('Add to cart failed:', error);
    } finally {
      if (submitButton instanceof HTMLButtonElement) {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
      }
    }
  }

  #onVariantUpdate(event) {
    const variantId = this.refs.variantId;

    if (!(variantId instanceof HTMLInputElement)) return;

    const productId = this.dataset.productId;

    if (
      event.detail?.data?.productId &&
      productId &&
      event.detail.data.productId !== productId
    ) {
      return;
    }

    const resource = event.detail?.resource;

    if (!resource || !resource.id) return;

    variantId.value = resource.id;
    variantId.disabled = resource.available === false;

    const submitButton = this.refs.submitButton;

    if (submitButton instanceof HTMLButtonElement) {
      submitButton.disabled = resource.available === false;

      const buttonText = submitButton.querySelector('.add-to-cart-text__content');

      if (buttonText instanceof HTMLElement) {
        buttonText.textContent =
          resource.available === false ? 'Sold out' : 'Add to cart';
      }
    }
  }
}

if (!customElements.get('product-form-component')) {
  customElements.define('product-form-component', ProductFormComponent);
}